module.exports = __webpack_public_path__ + "media/images/athletes/1014-921de9ffc74add075af4e2cf80c8ed39.png";